module.exports = __webpack_public_path__ + "img/4.9200eb2d.svg";